
<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'climateActivists',
    // name: 'climateProtectors',

    metaInfo: { title: 'ClimateActivists' },
    // metaInfo: { title: 'ClimateProtectors' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-climate',
        'immediate-steps',
        'doom',
        'bloom',
        'ten-steps-to-decarbonize',
        'misconceptions',
        // 'features',
        // 'marketing',
        // 'contact-us',
        // 'news',
        // 'social-media',
        // 'newsletter',
        // 'info-alt',
        // 'in-memory',
        // 'in-memory2',
        // 'recent-works',
        // 'affiliates',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'home',
      },
    },
  }
</script>
